"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDateToShortenedMonthString = transformDateToShortenedMonthString;
function transformDateToShortenedMonthString(date) {
    const dateToStringify = new Date(date);
    const year = dateToStringify.getUTCFullYear().toString();
    const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][dateToStringify.getUTCMonth()];
    const day = dateToStringify.getUTCDate().toString();
    return `${day} ${month}, ${year}`;
}
//# sourceMappingURL=transformDateToShortenedMonthString.js.map